<template>
    <div class="container">
      <div class="main">
        <div class="title">
          <div style="float: left; font-weight: bold; color: #666666;">{{summaryTitle}}</div>
          <div style="float: right">
            <el-date-picker
              @change="getDate"
              size="small"
              v-model="value"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
          <div style="clear:both"></div>
        </div>
        <!--切换-->
        <div>
          <div style="margin-top: 20px;margin-left: 10px;float: left">
            <el-radio-group @change="Parameter" v-model="radio" size="small">
              <!--<el-radio-button label="全部" ></el-radio-button>-->
              <el-radio-button v-for="(item,index) in radioLabel" :key="index" :label=item.name></el-radio-button>
            </el-radio-group>
          </div>
          <el-dropdown @command="handleCommand" v-if="dropdown" style="margin-top: 20px;margin-right: 10px;float: right">
            <el-button type="primary" size="small">更多<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item,index) in dropdownName" :key="index" :command="item.name">{{item.name}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <div style="clear:both"></div>
        </div>
        <!--项目级-->
        <div v-if="sectId === ''">
          <div v-if="dataEmpty === true">
            <div ref="chart" id="pie" style="width: 300px;height:260px;float: left;margin-top: 20px"></div>
            <div style="float: right;margin-right: 10px">
              <template>
                <el-table
                  height="250px"
                  @row-click="pieTrigger"
                  :cell-style="cellStyle"
                  :data="tableData"
                  style="width: 100%"
                  :header-cell-style="{color:'#666666'}">
                  <el-table-column
                    prop="color"
                    label="图例"
                    width="120">
                    <template slot-scope="scope">
                      <div :style="{'border-radius': '2px','width': '10px','height': '10px', 'background-color': scope.row.color}"></div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="标段"
                    width="120">
                  </el-table-column>
                  <el-table-column
                    prop="total"
                    label="数量"
                    width="120">
                  </el-table-column>
                  <el-table-column
                    prop="running"
                    label="占比"
                    width="120">
                  </el-table-column>
                </el-table>
              </template>
            </div>
            <div style="clear:both"></div>
          </div>
        </div>
        <!--标段级-->
        <div v-if="sectId !== ''">
          <div v-if="dataEmpty === true">
            <div ref="chartLot" id="bar" style="width: 400px;height:285px;float: left;padding-left: 15px"></div>
            <div style="float: right;margin-right: 10px">
              <template>
                <el-table
                  height="250px"
                  @row-click="pieTrigger"
                  :cell-style="cellStyle"
                  :data="tableDataBar"
                  style="width: 100%"
                  :header-cell-style="{color:'#666666'}">
                  <el-table-column
                    prop="date"
                    label="日期"
                    width="120">
                  </el-table-column>
                  <el-table-column
                    prop="total"
                    label="总数"
                    width="90">
                  </el-table-column>
                  <el-table-column
                    prop="running"
                    label="流转中"
                    width="90">
                  </el-table-column>
                  <el-table-column
                    prop="end"
                    label="完成"
                    width="90">
                  </el-table-column>
                </el-table>
              </template>
            </div>
            <div style="clear:both"></div>
          </div>
        </div>
        <!--缺省页-->
        <div style="width: 100%;text-align: center;height: 265px;margin-top: 20px" v-if="dataEmpty === false">
          <el-image style="margin: 0 auto;width: 200px" :src="require('../../../static/images/Nodata.svg')"></el-image>
        </div>
      </div>
    </div>
</template>

<script>
    // 引入 echarts
    import * as echarts from 'echarts';

    export default {
      name: "ZjData",
      props: ['summaryTitle','keyCode'],
      data() {
        return {
          // 查询时间
          value:[],
          radio: '',
          radioLabel: [],
          dropdownName: [],
          dropdown: false,
          state:'',
          // 行列边框颜色
          commenClass:'color:#606266!important;padding:0px;',

          tableData: [],
          pieColor: ["#FBD437", "#4ECB73", '#3AA1FF', '#ACDF82' , '#82DFBE', '#36CBCB', '#88D1EA', '#975FE5', '#DC81D2', '#F2637B', '#CC0001','#5DB1FF','#D6431A','#FFCD42'],
          data:'',

          // 查询数据
          projectId:'',
          sectId:'',
          code:'',
          startDate:'',
          endDate:'',

          // 图表数据
          pieData: [],
          titleSum: '',
          pieShow: false,

          // 数据为空状态
          dataEmpty: true,
          pieName: '质检资料',

          // 标段数据
          tableDataBar:[],
          xData: [],
          yData: [],
          lotTableData: [],

          // 枚举value
          enumeration:'',

          // 排序参数
          sorting:''
        }
      },
      created() {
        // 默认日期前一天
        let dateTime = new Date();
        dateTime = dateTime.setDate(dateTime.getDate() - 1);
        dateTime = this.dateFomat(new Date(dateTime));
        this.value.push(dateTime);
        this.value.push(dateTime);

        // 类
        this.enumeration = this.keyCode;

        this.getRadio();

        // 获取项目和标段ID
        var projectInfo = JSON.parse(sessionStorage.getItem("projectInfo"));
        if (!!projectInfo) {
          if (!!projectInfo.projectId) {
            this.projectId = projectInfo.projectId;
          }
          if (!!projectInfo.mainSectionId) {
            this.sectId = projectInfo.mainSectionId;
          }
        }
        this.startDate = this.value[0];
        this.endDate = this.value[1];

        if(this.sectId === '') {
          // 获取数据
          this.getDatas();
          this.optionPie();
        }

        if(this.sectId !== '') {
          this.getDatas();
        }
      },
      methods: {
        // 获取切换数据
        getRadio() {
          this.radioLabel = [];
          this.dropdownName = [];
          this.$axios.get(`/api/category/getCategoryList/key?value=${this.enumeration}`).then(res => {
            var data = res.data.data;
            if(this.code === '') {
              this.code = data[0].code;
            }
            this.radio = data[0].name;
            // this.state = data[0].name;
            for (var i = 0; i < data.length; i++) {
              if(i < 3) {
                this.radioLabel.push(data[i])
              }
              if(i > 2) {
                this.dropdown = true;
                this.dropdownName.push(data[i])
              }
            }
          });
          this.getDatas();
        },
        // 获取数据
        getDatas() {
          // 排序参数
          if(this.sectId === '') {
            this.sorting = 'sectSort'
          } else {
            this.sorting = 'date'
          }
          this.pieData = [];
          var index = 0,arr = [],sum = 0,sumOne = 0;
          this.$axios.get('/fusion/moduleUseStatis/getList',{params:{
              projectId: this.projectId,
              sectId: this.sectId,
              code: this.code,
              startDate: this.startDate,
              endDate: this.endDate,
              sortPro: this.sorting ,
              sortType: '1'
            }}).then( res => {
            this.lotTableData = res.data;
            for(var i = 0; i < res.data.length; i++) {
              if(i === 0) {
                for(var t = 0; t < res.data.length; t++) {
                  if(res.data[t].sectId === res.data[i].sectId) {
                    sum += res.data[t].total;
                  }
                }
                // 表格数据
                var obj = {};
                obj.total = sum;
                obj.name = res.data[i].sectionName;
                arr.push(obj);
                sum = 0;
              } else {
                if (res.data[i].sectId !== res.data[i-1].sectId ) {
                  for(var w = 0; w < res.data.length; w++) {
                    if(res.data[w].sectId === res.data[i].sectId) {
                      sum += res.data[w].total;
                    }
                  }
                  // 表格数据
                  var obj1 = {};
                  obj1.total = sum;
                  obj1.name = res.data[i].sectionName;
                  arr.push(obj1);
                  sum = 0;
                }
              }
            }
            // 计算总和
            for(var o = 0; o < arr.length; o++) {
              sumOne += arr[o].total
            }
            for( var p =0; p < arr.length; p++) {
              // 计算占比 添加占比
              var trr = arr[p].total / sumOne * 100;
              arr[p].running = trr.toFixed(2) + '%';
              // 添加图例颜色
              arr[p].color = this.pieColor[p]
            }
            for( var g = 0; g < arr.length; g++) {
              // 图表数据
              var pieObj = {};
              pieObj.value = arr[g].total;
              pieObj.name = arr[g].name;
              this.pieData.push(pieObj);
            }
            this.titleSum = sumOne;
            this.tableData = arr;

            // 控制总数是否显示
            if(this.pieData.length !== 0) {
              this.pieShow = true;
              this.dataEmpty = true
            } else {
              this.pieShow = false;
              this.dataEmpty = false
            }
            if(this.sectId === '') {
              // 获取数据
              this.optionPie();
            }
            if(this.sectId !== '') {
              this.tableDataBar = this.lotTableData;
              this.compileBarData();
              this.optionBar();
            }
          })
        },
        getDate() {
          this.startDate = this.dateFomat(this.value[0]);
          this.endDate = this.dateFomat(this.value[1]);
          this.getDatas();
        },
        // 切换事件
        Parameter(val) {
          this.pieName = val;
          // this.state = val;
          for(var i = 0; i < this.radioLabel.length; i++) {
            if(this.radioLabel[i].name === val) {
              this.code = this.radioLabel[i].code
            }
          }
          this.getDatas();
        },
        // 下拉菜单事件
        handleCommand(command) {
          this.state = command;
          for(var i = 0; i < this.dropdownName.length; i++) {
            if(this.dropdownName[i].name === command) {
              this.code = this.dropdownName[i].code
            }
          }
          this.getDatas();
        },
        optionPie() {
          this.$nextTick(function () {
            // 通过id获取获取画布
            // const myChart = echarts.init(document.getElementById('pie'));
            var pie = this.$refs.chart;
            if(pie) {
              const myChart = echarts.init(pie);
              //图表数据
              let option = {
                color: this.pieColor,
                tooltip: {
                  trigger: 'item',
                  formatter: '{a} <br/>{b}: {c} ({d}%)'
                },
                /* legend: {
                   bottom: 0,
                   left: 'center',
                   data: ['直接访问', '邮件营销', '联盟广告',]
                 },*/
                title: {
                  show: this.pieShow,
                  text: '总数: '  +  this.titleSum + '份',
                  x: 'center',
                  y: 'center',
                  top: '122',
                  textStyle: {
                    fontSize: 20,
                    color: '#777',
                    fontWeight: 800
                  }
                },
                series: [
                  {
                    name: this.pieName,
                    type: 'pie',
                    radius: ['50%', '70%'],
                    avoidLabelOverlap: false,
                    label: {
                      show: false,
                      position: 'center'
                    },
                    emphasis: {
                      label: {
                        show: false,
                        fontSize: '30',
                        fontWeight: 'bold'
                      }
                    },
                    labelLine: {
                      show: false
                    },
                    data: this.pieData
                  }
                ]
              };
              // 使用刚指定的配置项和数据显示图表。画布为 myCharts  true为显示
              if (option && typeof option === "object") {
                myChart.setOption(option, true);
              }
              // 设置默认高亮的
              myChart.dispatchAction({type: 'highlight',seriesIndex: 0,dataIndex: 0});
              myChart.on('mouseover', function(e) {
                //当检测到鼠标悬停事件，取消默认选中高亮
                myChart.dispatchAction({type: 'downplay',seriesIndex: 0,dataIndex: 0})
              });
              //检测鼠标移出后显示之前默认高亮的那块
              myChart.on('mouseout', function(e) {
                myChart.dispatchAction({
                  type: 'highlight',
                  seriesIndex: 0,
                  dataIndex: 0
                });
              });
            }
          })
        },
        //设置单元格背景
        cellStyle({row, column, rowIndex, columnIndex}) {
          return 'height:40px!important;' + this.commenClass
        },
        pieTrigger(val) {
          this.data = val.data
        },
        // 日期格式化
        dateFomat(data){
          var date = new Date(data);
          var YY = date.getFullYear() + '-';
          var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
          var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
          return YY + MM + DD;
        },

        // 编辑柱形图数据（标段）
        compileBarData() {
          this.xData = [];
          this.yData = [];
          // this.barData.sort(this.compare('date'));
          for(var i = 0; i < this.lotTableData.length; i++) {
            this.xData.push(this.lotTableData[i].date);
            this.yData.push(this.lotTableData[i].total);
          }

          // 数据是否为空
          if(this.lotTableData.length !== 0) {
            this.dataEmpty = true
          } else {
            this.dataEmpty = false
          }

        },
        // 标段图表渲染
        optionBar() {
          this.$nextTick(function () {
            // 通过id获取获取画布
            // const myChart = echarts.init(document.getElementById('bar'));
            var bar = this.$refs.chartLot;
            if(bar) {
              const myChart = echarts.init(bar);
              //图表数据
              let option = {
                color: ['#3AA1FF'],
                tooltip: {},
                xAxis: {
                  type: 'category',
                  data: this.xData,
                  name:'日期',
                  nameGap: 15
                },
                yAxis: {
                  type: 'value',
                  data: this.yData,
                  name:'总数(份)'
                },
                series: [{
                  data: this.yData,
                  type: 'bar',
                  showBackground: true,
                  backgroundStyle: {
                    color: 'rgba(220, 220, 220, 0.8)'
                  }
                }],
              };
              // 使用刚指定的配置项和数据显示图表。画布为 myCharts  true为显示
              if (option && typeof option === "object") {
                myChart.setOption(option, true);
              }
            }
          })
        },
      },
    }
</script>

<style scoped>
  .container {
    background-color: #F4F5F4;
    width: 100%;
  }
  .main {
    background-color: #ffffff;
    /*width: 840px;*/
    width: 100%;
    height: 400px;
    margin-left: 10px;
  }
  .title {
    line-height: 56px;
    height: 56px;
    border-bottom: 1px solid #E9E9E9;
    margin: 0px 10px;
  }

  /*滚动条的宽度*/
  /deep/ .el-table__body-wrapper::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  /*滚动条滑块*/
  /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #ddd;
    /*border-radius: 3px;*/
  }
</style>




// WEBPACK FOOTER //
// src/views/Summary/SummaryData.vue